<template>
  <canvas
    class="line-chart"
    :id="id"
  >
    <!---->
  </canvas>
</template>

<script>
import id from '@/helpers/id'
import Chart from 'chart.js'

/**
 * 'LineChart' Component
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */
export default {
  name: 'LineChart',
  props: {
    labels: {
      type: Array,
      default () {
        return []
      }
    },
    datasets: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      id: id(),
      chart: null,
      ctx: null
    }
  },
  watch: {
    labels () {
      this.chart.data.labels = this.labels
      this.chart.update()
    },
    datasets () {
      this.chart.data.datasets = this.datasets
      this.chart.update()
    }
  },
  mounted () {
    this.chart = new Chart(this.id, {
      type: 'line',
      data: {
        labels: this.labels
      },
      datasets: this.datasets,
      options: {
        maintainAspectRatio: false,
        legend: {
          position: 'top',
          labels: {
            boxWidth: 14
          }
        },
        scales: {
          yAxes: [
            {
              gridLines: {
                display: false
              },
              ticks: {
                fontColor: '#cdcdcd',
                beginAtZero: true
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false
              },
              ticks: {
                fontColor: '#cdcdcd'
              }
            }
          ]
        }
      }
    })
  },
  beforeDestroy () {
    this.chart.destroy()
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
.line-chart {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/_shared/charts/line-chart.vue